export function getPlaceholder(f) {
    switch (f === null || f === void 0 ? void 0 : f.contentType) {
        case 'text/html':
            return '/assets/placeholder-web.png';
        case 'application/pdf':
            return '/assets/placeholder-document.png';
        case 'video/mp4':
            return '/assets/placeholder-video.png';
        case 'image/png':
        case 'image/jpeg':
            return '/assets/placeholder-image.png';
        case 'application/x-kiwi-kiosk-1':
        case 'layout':
            return '/assets/placeholder-template.png';
    }
    return '';
}
export function getFileType(file) {
    switch (file.contentType.toLowerCase()) {
        case "playlist":
        case "layout": return "Folder";
        case "application/x-kiwi-kiosk-1": return "Template";
        case "image/jpeg":
        case "image/png": return "Image";
        case "video/mp4": return "Video";
        default: return "";
    }
}
export function getRandomColor() {
    let lum = -0.25;
    let hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    let rgb = "#", c, i;
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }
    return rgb;
}
//# sourceMappingURL=utils.js.map